<div class="input-wrapper">
  <div class="wrapper-top">
    <button type="button" aria-label="minus" class="decrement-count" (click)="minus()"></button>
    <input class="input-count" [disabled]="disableInput" [ngModel]="qty" [min]="0" [max]="max"
      [placeholder]="'inputQty' | transloco" (keyup.enter)="edit($event.target.value)"
      (change)="edit($event.target.value)">
    <button type="button" aria-label="plus" class="increment-count" (click)="plus()"></button>
  </div>
  <div class="wrapper-bot">
    <p *ngIf="type === 'parent'" class="type-package">{{namePack | transloco}}</p>
    <p *ngIf="type === 'child'" class="type-package">{{namePack}}</p>
  </div>
</div>
